import {each, reduce} from 'lodash';

const radianInKm = 6371; // km

// Converts numeric degrees to radians
// Source: https://stackoverflow.com/a/18883819
const toRad = (value) => {
    return value * Math.PI / 180;
};

// This function takes in latitude and longitude of two location
// and returns the distance between them as the crow flies (in km)
// Source: https://stackoverflow.com/a/18883819
const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const distanceLat = toRad(lat2 - lat1);
    const distanceLng = toRad(lng2 - lng1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);
    const a = Math.sin(distanceLat / 2) * Math.sin(distanceLat / 2) +
        Math.sin(distanceLng / 2) * Math.sin(distanceLng / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return radianInKm * c;
};

const updateCloserAgencyInfos = (closerAgency) => {
    document.querySelector('[data-closer-agency="phone"]').textContent = closerAgency.phone_number_national;
    document.querySelector('[data-closer-agency="name"]').textContent = closerAgency.name;
    document.querySelector('[data-closer-agency="hours"]').textContent = closerAgency.hours[(new Date()).getDay()];
    Livewire.emit('agency:selected:updated', closerAgency.id);
};

export default class SelectCloserAgency {

    static init() {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const closerAgency = reduce(app.agencies, (closerAgency, agency) => {
                    agency.distance = calculateDistance(
                        position.coords.latitude,
                        position.coords.longitude,
                        agency.lat,
                        agency.lng
                    );
                    if (! closerAgency || agency.distance < closerAgency.distance) {
                        return agency;
                    }

                    return closerAgency;
                }, null);
                updateCloserAgencyInfos(closerAgency);
            }
        );
        each(document.querySelectorAll('[data-select-agency]'), (element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                updateCloserAgencyInfos(app.agencies.filter((agency) => {
                    return agency.id === parseInt(e.currentTarget.dataset.selectAgency);
                })[0]);
            });
        });
    }

}
